import { useMemo } from 'react';

const isRemoteDeployed = import.meta.env.VITE_IS_REMOTE_DEPLOYMENT === 'true';

const getLocalOrigin = (): string => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return `https://${import.meta.env.VITE_HOST}:${import.meta.env.VITE_PORT}`;
};

export interface RedirectItem {
  url: string;
  state?: any;
}

export const getParameterByName = (name: string, url: string) => {
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);

  if (!results) {
    return '';
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getMainApiUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_MAIN_API_LOCAL_PREFIX}`
    : `${import.meta.env.VITE_SERVER_MAIN_API_HOST}/api`;
};

export const getRainRadarUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_RAIN_RADAR_API_LOCAL_PREFIX}`
    : import.meta.env.VITE_SERVER_RAIN_RADAR_API_HOST;
};

export const getPublicUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_PUBLIC_API_LOCAL_PREFIX}`
    : import.meta.env.VITE_SERVER_PUBLIC_API_HOST;
};

export const getGisUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_GIS_API_LOCAL_PREFIX}`
    : import.meta.env.VITE_SERVER_GIS_API_HOST;
};

export const getOneSoilUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_ONE_SOIL_API_LOCAL_PREFIX}`
    : import.meta.env.VITE_ONE_SOIL_API_HOST;
};

export const getOneSoilCredentials = () => {
  return import.meta.env.VITE_ONE_SOIL_API_CREDENTIALS;
};

export const getGigyaUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_GIGYA_API_LOCAL_PREFIX}`
    : import.meta.env.VITE_GIGYA_API_HOST;
};

export const getPipelineUrl = () => {
  return !isRemoteDeployed
    ? `${getLocalOrigin()}/${import.meta.env.VITE_PIPELINE_LOCAL_PREFIX}`
    : import.meta.env.VITE_PIPELINE_PATH;
};

const getSearchParameters = () => {
  const searchString = window.location.search.substring(1);
  const params = searchString.split('&');
  const hash: Record<string, string> = {};

  if (searchString !== '') {
    params.forEach((param) => {
      const val = param.split('=');
      hash[decodeURIComponent(val[0])] = decodeURIComponent(val[1]);
    });
  }
  return hash;
};

export const useGetSearchParameters = () => {
  return useMemo(() => getSearchParameters(), []);
};

export const toCamelCase = (str: string) => {
  const s = str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    ?.map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
    .join('');

  return s ? s.slice(0, 1).toLowerCase() + s.slice(1) : str;
};
